import React, { useState, useEffect } from "react";
import { Table, Card, message, Tag, Tooltip } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { getDevices } from "../services/api";

const DeviceList = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);

  // 判断设备是否在线（最后更新时间在300秒内）
  const isDeviceOnline = (lastUpdatedTimestamp) => {
    const now = Math.floor(Date.now() / 1000);
    return now - lastUpdatedTimestamp < 300;
  };

  const fetchDevices = async () => {
    try {
      setLoading(true);
      const data = await getDevices();
      setDevices(data || []);
    } catch (error) {
      console.error("获取设备列表失败:", error);
      message.error(
        "获取设备列表失败: " + (error.response?.data?.error || "未知错误")
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDevices();

    // 每30秒刷新一次设备列表
    const interval = setInterval(() => {
      fetchDevices();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const columns = [
    {
      title: "设备ID",
      dataIndex: "id",
      key: "id",
      width: 120,
    },
    {
      title: "状态",
      dataIndex: "lastUpdatedTimestamp",
      key: "status",
      width: 100,
      render: (lastUpdatedTimestamp) => {
        const online = isDeviceOnline(lastUpdatedTimestamp);
        return (
          <Tag color={online ? "success" : "error"}>
            <span
              className={`online-status ${online ? "online" : "offline"}`}
            ></span>
            {online ? "在线" : "离线"}
          </Tag>
        );
      },
    },
    // {
    //   title: "版本",
    //   dataIndex: "version",
    //   key: "version",
    //   width: 100,
    // },
    {
      title: "滚筒计数",
      dataIndex: "rollerCount",
      key: "rollerCount",
      width: 120,
    },
    {
      title: "RPM",
      dataIndex: "rpm",
      key: "rpm",
      width: 100,
    },
    {
      title: "卷收故障",
      dataIndex: "rollFault",
      key: "rollFault",
      width: 120,
      render: (fault) => (
        <Tag color={fault ? "error" : "success"}>{fault ? "故障" : "正常"}</Tag>
      ),
    },
    {
      title: "经纱断纱",
      dataIndex: "warpBreak",
      key: "warpBreak",
      width: 120,
      render: (fault) => (
        <Tag color={fault ? "error" : "success"}>{fault ? "断纱" : "正常"}</Tag>
      ),
    },
    {
      title: "纬纱断纱",
      key: "weftBreak",
      width: 300,
      render: (_, record) => (
        <>
          <Tooltip title="纬纱1">
            <Tag
              color={record.weftBreak1 ? "error" : "success"}
              style={{ marginRight: 5 }}
            >
              纬1: {record.weftBreak1 ? "断纱" : "正常"}
            </Tag>
          </Tooltip>
          <Tooltip title="纬纱2">
            <Tag
              color={record.weftBreak2 ? "error" : "success"}
              style={{ marginRight: 5 }}
            >
              纬2: {record.weftBreak2 ? "断纱" : "正常"}
            </Tag>
          </Tooltip>
          <Tooltip title="纬纱3">
            <Tag
              color={record.weftBreak3 ? "error" : "success"}
              style={{ marginRight: 5 }}
            >
              纬3: {record.weftBreak3 ? "断纱" : "正常"}
            </Tag>
          </Tooltip>
          <Tooltip title="纬纱4">
            <Tag color={record.weftBreak4 ? "error" : "success"}>
              纬4: {record.weftBreak4 ? "断纱" : "正常"}
            </Tag>
          </Tooltip>
        </>
      ),
    },
    {
      title: "最后更新时间",
      dataIndex: "lastUpdated",
      key: "lastUpdated",
      width: 180,
    },
  ];

  return (
    <Card
      title="设备列表"
      extra={
        <Tooltip title="刷新">
          <SyncOutlined
            spin={loading}
            onClick={fetchDevices}
            style={{ cursor: "pointer", fontSize: "16px" }}
          />
        </Tooltip>
      }
    >
      <Table
        columns={columns}
        dataSource={devices}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1300 }}
      />
    </Card>
  );
};

export default DeviceList;
